import { Component, Input, Output, EventEmitter } from '@angular/core';

import { PuiTabComponent, PuiTabsComponent } from '../tab/index';

@Component({
  template: '<ng-content></ng-content>',
  selector: 'pui-portlet-tool',
})
export class PuiPortletToolComponent {
}

@Component({
  template: '<ng-content></ng-content>',
  selector: 'pui-portlet-action',
})
export class PuiPortletActionComponent {
}

// use directive because of (metronic) css structure
// should be component
@Component({
  template: `
    <div class="caption">
      <span class="caption-subject bold">{{ title }}</span>
      <span class="caption-helper">{{ description }}</span>
    </div>
    <div class="tools">
      <a *ngIf="options.toggle" href="javascript:;" class="collapse" (click)="onToggle()"></a>
      <a *ngIf="options.fullscreen" href="javascript:;" class="fullscreen" (click)="onFullscreen()"></a>
      <ng-content select="pui-portlet-tool"></ng-content>
    </div>
    <ul class="nav nav-tabs" *ngIf="tabset !== undefined">
      <li *ngFor="let tab of tabset.tabs" (click)="onSelect(tab)" [class.active]="tab.active">
        <a href="javascript:void(0)">{{ tab.title }}</a>
      </li>
    </ul>
    <div class="actions">
      <ng-content select="pui-portlet-action"></ng-content>
    </div>
  `,
  selector: 'pui-portlet-header'
})
export class PuiPortletHeaderComponent {
  @Input('options') options: {
    toggle?: boolean,
    fullscreen?: boolean
  } = {};
  @Input() title: string;
  @Input() description: string;
  @Input() tool: PuiPortletToolComponent;
  @Input() action: PuiPortletActionComponent;

  @Output() toggle = new EventEmitter<boolean>();
  @Output() fullscreen = new EventEmitter<boolean>();

  private collapsed = false;
  private fullscreend = false;

  /** @internal */
  tabset: PuiTabsComponent;

  onSelect(tab: PuiTabComponent) {
    if (this.tabset) {
      this.tabset.selectTab(tab);
    }
  }

  onToggle() {
    this.collapsed = !this.collapsed;
    this.toggle.emit(this.collapsed);
  }

  onFullscreen() {
    this.fullscreend = !this.fullscreend;
    this.fullscreen.emit(this.fullscreend);
  }
}

